var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.875 22.5C43.875 34.3051 34.3051 43.875 22.5 43.875C10.6949 43.875 1.125 34.3051 1.125 22.5C1.125 10.6949 10.6949 1.125 22.5 1.125C34.3051 1.125 43.875 10.6949 43.875 22.5Z",
    stroke: "#F4F4F4",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 18.375C17.3956 18.375 18.375 17.3956 18.375 16.1875C18.375 14.9794 17.3956 14 16.1875 14C14.9794 14 14 14.9794 14 16.1875C14 17.3956 14.9794 18.375 16.1875 18.375Z",
    fill: "#6187EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0104 19.8334H14.3646C14.1633 19.8334 14 19.9967 14 20.198V31.1355C14 31.3367 14.1633 31.5 14.3646 31.5H18.0104C18.2117 31.5 18.375 31.3367 18.375 31.1355V20.198C18.375 19.9967 18.2117 19.8334 18.0104 19.8334Z",
    fill: "#6187EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8729 19.3309C27.3146 18.7972 25.3656 19.266 24.1967 20.1068C24.1566 19.95 24.0137 19.8333 23.8438 19.8333H20.198C19.9967 19.8333 19.8334 19.9967 19.8334 20.1979V31.1354C19.8334 31.3367 19.9967 31.5 20.198 31.5H23.8438C24.045 31.5 24.2084 31.3367 24.2084 31.1354V23.275C24.7975 22.7675 25.5566 22.6056 26.1779 22.8696C26.7801 23.1241 27.125 23.7453 27.125 24.5729V31.1354C27.125 31.3367 27.2884 31.5 27.4896 31.5H31.1355C31.3367 31.5 31.5 31.3367 31.5 31.1354V23.8386C31.4585 20.8425 30.049 19.7334 28.8729 19.3309Z",
    fill: "#6187EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ac63ad7db945008345a230a40e4e7dd0.svg";
export { ForwardRef as ReactComponent };